import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, css } from 'styled-components';
import { Media } from '../../theme/Media';
const Scroll = styled.div `
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    position: relative;
    overflow: auto;
  }
`;
const Shadow = styled.div `
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    position: relative;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    transition: border-color 100ms;
    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      width: 10px;
      bottom: 0;
      height: calc(100% - 4px);
      box-shadow: 0 0 10px -2px rgb(0 0 0 / 70%);
      opacity: 0;
      transition: opacity 100ms;
    }
    &:before {
      right: calc(100% + 1px);
    }
    &:after {
      left: calc(100% + 1px);
    }
    ${(props) => props.$showStart &&
    css `
        border-left-color: ${({ theme }) => theme.colors.grey10_1};
        &:before {
          opacity: 1;
        }
      `}
    ${(props) => props.$showEnd &&
    css `
        border-right-color: ${({ theme }) => theme.colors.grey10_1};
        &:after {
          opacity: 1;
        }
      `}
  }
`;
const Wrapper = styled.div `
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    position: relative;
    overflow: hidden;
    margin: 0 -1px;
    max-width: calc(100% + 2px);
  }
`;
const ScrollableWrapper = ({ children, className, pending = false, isCollapsedNav = true }) => {
    const [showStart, setShowStart] = React.useState(false);
    const [showEnd, setShowEnd] = React.useState(false);
    const scrollableElement = React.useRef(null);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const onScroll = React.useCallback(() => {
        const { scrollWidth = 0, scrollLeft = 0, offsetWidth = 0 } = scrollableElement.current || {};
        setShowStart(scrollLeft > 0);
        setShowEnd(scrollLeft + offsetWidth + 4 < scrollWidth);
    }, [setShowStart, setShowEnd]);
    React.useEffect(() => {
        const ref = scrollableElement.current;
        ref?.addEventListener('scroll', onScroll);
        return () => {
            ref?.removeEventListener('scroll', onScroll);
        };
    }, [onScroll, scrollableElement]);
    React.useEffect(() => {
        if (!pending) {
            onScroll();
        }
    }, [onScroll, pending, isCollapsedNav]);
    return (_jsx(Wrapper, { $isCollapsedNav: isCollapsedNav, children: _jsx(Shadow, { $showEnd: showEnd, $showStart: showStart, className: className, $isCollapsedNav: isCollapsedNav, children: _jsx(Scroll, { ref: scrollableElement, $isCollapsedNav: isCollapsedNav, children: children }) }) }));
};
export default ScrollableWrapper;
